import Footer from '@/components/common/Footer';
import { Outlet } from 'react-router-dom';

export function AuthLayout() {
  return (
    <div className="min-h-screen flex flex-col relative overflow-hidden font-roboto">
      {/* Background Image */}
      <div
        className="hidden xl:block absolute inset-0 bg-no-repeat bg-cover bg-left-top"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--primary) / 0.6), rgba(255,255,255,0.6)), url('/images/login-bg-ten.jpg')",
        }}
      />
      <div
        className="xl:hidden absolute inset-0 bg-repeat bg-contain"
        style={{
          backgroundImage:
            "linear-gradient(hsl(var(--primary) / 0.6), rgba(255,255,255,0.6)), url('/images/login-bg-mobile-ten.jpg')",
        }}
      />

      {/* Main Content */}
      <div className="relative flex-1 flex items-center justify-center p-4">
        <Outlet />
      </div>

      <Footer isInvert />
    </div>
  );
}
